import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { useNavigate } from 'react-router-dom';
import HelpInfos from '../../../../HelpInfo';
import HelpData from "../../../../../Data/Help.json"
import Help from '../../../../../Types/Help';
import { DemandeQardDto } from '../../../../../Models/DemandeQardDto';
import GarantieQard from '../../../../../Models/GarantieQard';
import ParamsQard from '../../../../../Models/ParamsQard';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import { PrintTabamortdemande } from '../../../../../utilitaires/PrintTabAmortDemande';
import { useAgence } from '../../../../../AgenceContext';

interface SelectData {
  value: string;
  label: string;
}

const DemandeQard = () => {
  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  // USER TOKEN
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [ajoutActve, setAjoutActif] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [supActive, setSupActive] = useState(true);
  const [impActive, setImpActive] = useState(true);
  const [actuActive, setActActive] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [consulActive, setConsulActive] = useState(false);
  const [sbmit, setSbmit] = useState('');
  const [DataGarantie, SetDataGarantie] = useState<SelectData[]>([]);
  const Branch=useAgence();
  const [Numcli, setNumcli] = useState("");
  const [CodeQard, setCodeQard] = useState("");

  // ✅ FIX 1: State des garanties remonté dans le parent pour synchronisation totale
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);

  // Paramètres du type de Qard sélectionné (pour les contrôles avant soumission)
  const [paramsQard, setParamsQard] = useState<ParamsQard | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false);
    setModifActve(true);
    setEnregActve(true);
    setSupActive(true);
    setImpActive(true);
    setActActive(true);
    setAnnulActive(true);
    setConsulActive(false);
  }

  const SetStart = () => {
    SetDataGarantie([]);
    // ✅ FIX 2: Reset du tableau garanties à l'ajout
    setGarantiesTableau([]);
    localStorage.removeItem(Data.LocalVariable.garantie);
    setSbmit('add');
    setAjoutActif(true);
    setEnregActve(false);
    setAnnulActive(false);
    setConsulActive(true);
    setParamsQard(null);
    form.resetFields();
  };

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false);
  };

  // ✅ FIX 3: handleAnulle vide maintenant aussi le tableau garanties de Tab2
  function handleAnulle() {
    let coduti = form.getFieldValue('CODUTI');
    form.resetFields();
    localStorage.clear();
    form.setFieldValue('CODUTI', coduti);
    initialiazeButton();
    SetDataGarantie([]);
    setNumcli('');
    setParamsQard(null);
    // ✅ Vider le tableau garanties dans Tab2
    setGarantiesTableau([]);
  }

  function cunsultButton() {
    setAnnulActive(false);
    setModifActve(false);
    setImpActive(false);
  }

  function modifButton() {
    setSbmit('update');
    setModifActve(true);
    setAjoutActif(true);
    setEnregActve(false);
    setConsulActive(true);
    setImpActive(true);
  }

  function LoadGarantie() {
    SetDataGarantie([]);
    let dataGarantie: SelectData[] = [];

    try {
      let numcli = form.getFieldValue('NUMCLI');
      numcli += Data.LocalVariable.separator + 'CL';

      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetGarantie,
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader(),
          CypherSearch: Crypter.encrypt(JSON.stringify(numcli)),
        },
      };
      axios(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              let datas = res.Result.Table;
              let filtered = datas.filter((item: any) => item.CdEtat === '02');

              if (filtered.length === 0) {
                localStorage.setItem('garanties_client', '');
              } else {
                filtered.map((data: any) => {
                  dataGarantie.push({
                    value: data.codgar + '|' + data.dispo,
                    label:
                      data.codgar +
                      ' -> ' +
                      formatNumber(parseFloat(data.VALGARANTI)) +
                      ' XAF( disponible : ' +
                      formatNumber(parseFloat(data.dispo + '')) +
                      ' XAF)',
                  });
                });

                SetDataGarantie(dataGarantie);
                localStorage.setItem(
                  'garanties_client',
                  Crypter.encrypt(JSON.stringify(filtered))
                );
              }
            }
          }
        })
        .catch((error) => {
          SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
        });
    } catch (error) {
      SweetAlert.fire({
        title: "Veillez sélectionnez le client donc vous voulez charger les garantie",
        icon: 'warning',
      });
      localStorage.setItem('garanties_client', '');
    }
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id="Tab">
          <UserOutlined />
          Demande
        </span>
      ),
      children: (
        <Tab1
          form={form}
           Numcli={Numcli}
           CodeQard={CodeQard}
           setNumcli={setNumcli}
           setCodeQard={setCodeQard}
           setParamsQard={setParamsQard}
          disabled={ajoutActve}
          LoadGarantie={LoadGarantie}
        />
      ),
    },
    {
      key: '2',
      label: (
        <span id="Tab">
          <ContactsOutlined />
          Garanties
        </span>
      ),
      children: (
        // ✅ FIX 4: Passer le state et le setter à Tab2 pour contrôle total depuis le parent
        <Tab2
          form={form}
          Datagarantie={DataGarantie}
          garantiesTableau={garantiesTableau}
          setGarantiesTableau={setGarantiesTableau}
        />
      ),
    },
    {
      key: '3',
      label: (
        <span id="Tab">
          <UsergroupAddOutlined />
          Frais de service
        </span>
      ),
      children: <Tab3 form={form} />,
    },
  ];

  // Contrôles bloquants basés sur les paramètres du type de Qard sélectionné
  function controleParamsQard(values: any, garanties: GarantieQard[]): string[] {
    const erreurs: string[] = [];
    if (!paramsQard) return erreurs;

    if (paramsQard.IsGarantieObligatoir === true && garanties.length === 0) {
      erreurs.push(
        'La garantie est obligatoire pour le type de Qard ' +
          paramsQard.CodeQard +
          '. Veuillez sélectionner au moins une garantie avant de soumettre.'
      );
    }

    if (
      paramsQard.MontantMaxAuto > 0 &&
      Number(values.MontantDemande) > Number(paramsQard.MontantMaxAuto)
    ) {
      erreurs.push(
        'Le montant demandé (' +
          formatNumber(values.MontantDemande) +
          ' XAF) dépasse le montant maximum autorisé (' +
          formatNumber(paramsQard.MontantMaxAuto) +
          ' XAF).'
      );
    }

    if (
      paramsQard.NbrEchMax > 0 &&
      Number(values.NombreEch) > Number(paramsQard.NbrEchMax)
    ) {
      erreurs.push(
        "Le nombre d'échéances (" +
          values.NombreEch +
          ') dépasse le nombre maximum autorisé (' +
          paramsQard.NbrEchMax +
          ').'
      );
    }

    // Minimum de la promesse = MontantMinPromesse + (MontantDemande * TauxMinPromesse / 100)
    const minimumPromesse =
      (Number(paramsQard.MontantMinPromesse) || 0) +
      ((Number(values.MontantDemande) || 0) * (Number(paramsQard.TauxMinPromesse) || 0)) / 100;
    if (
      minimumPromesse > 0 &&
      values.MontantPromesse != null &&
      values.MontantPromesse !== '' &&
      Number(values.MontantPromesse) < minimumPromesse
    ) {
      erreurs.push(
        'Le montant de la promesse (' +
          formatNumber(values.MontantPromesse) +
          ' XAF) est inférieur au minimum exigé (' +
          formatNumber(minimumPromesse) +
          ' XAF).'
      );
    }

    // DatePremEch ne doit pas être antérieure à la date du jour
    if (values.DatePremEch) {
      const toDay = (d: any) => { const dt = new Date(d); dt.setHours(0, 0, 0, 0); return dt.getTime(); };
      if (toDay(values.DatePremEch) < toDay(user.datjour)) {
        erreurs.push(
          'La date du 1er remboursement ne doit pas être antérieure à la date du jour (' +
            new Date(user.datjour).toLocaleDateString('fr') +
            ').'
        );
      }
    }

    return erreurs;
  }

  // Aperçu : impression directe sans passer par la validation du formulaire (le rejet ne doit pas bloquer)
  const handleApercu = () => {
    const values = form.getFieldsValue(true);

    let Garanties: GarantieQard[] = garantiesTableau.map((data: DataTypeTable) => ({
      CodeGarantie: data.codgar,
      MontantCouvert: data.valCouvert,
    }));

    var DemandeQard: DemandeQardDto = {
      CODAGE: user.codage,
      DatePremEch: formatDate(values.DatePremEch),
      DateDemande: user.datjour,
      Numcli: values.NUMCLI,
      NOMCLI: values.lib_NUMCLI,
      Garanties: Garanties,
      ...values
    };

    DemandeQard.CodeQard = DemandeQard.CodeQard + ':' + '' + values.lib_CodeQard;
    PrintTabamortdemande(
      user.coduti ?? '',
      user.codage ?? '',
      Branch.agence?.LIBELLE ?? '',
      Branch.agence?.BANQUE ?? '',
      Branch.agence?.TELEPH ?? '',
      Branch.agence?.NUMREG ?? '',
      Branch.agence?.LICENCE ?? '',
      Branch.agence?.NUMREG ?? '',
      Branch.agence?.BPOSTE ?? '',
      Branch.agence?.VILLE ?? '',
      user.nomuti ?? '',
      values.lib_Periodicite,
      DemandeQard
    );
  };

  const onFinish = (val:any) => {
    const values = form.getFieldsValue(true);
    // alert(val.lib_Periodicite);

    let Garanties: GarantieQard[] = garantiesTableau.map((data: DataTypeTable) => ({
      CodeGarantie: data.codgar,
      MontantCouvert: data.valCouvert,
    }));

    // Blocage de la soumission si les contrôles paramétrés ne sont pas respectés
    if (sbmit === 'add' || sbmit === 'update') {
      const erreurs = controleParamsQard(values, Garanties);
      if (erreurs.length > 0) {
        SweetAlert.fire({
          title: 'Contrôles non respectés',
          html: erreurs.join('<br/><br/>'),
          icon: 'warning',
        });
        return;
      }
    }
    // if (Garanties.length !== 0) 
    //   {
        
      var DemandeQard: DemandeQardDto = {
        CODAGE: user.codage,
        DatePremEch: formatDate(values.DatePremEch),
        DateDemande: user.datjour,
        Numcli:values.NUMCLI,
        NOMCLI: values.lib_NUMCLI,
        Garanties: Garanties,
        ...values
      };
  

      if (sbmit === 'add') {
        SweetAlert.fire({
          title:
            'Voulez-vous enregistrer la demande de financment Qard de type ' +
            values.lib_CodeQard +
            '\n du client : ' +
            values.lib_NUMCLI +
            '\n à hauteur du montant : ' +
            formatNumber(values.MontantDemande) +
            ' XAF ?',
          showCancelButton: true,
          color: 'green',
          confirmButtonText: 'Yes',
          confirmButtonColor: 'green',
          cancelButtonColor: 'darkred',
          cancelButtonText: 'No',
          showLoaderOnConfirm: true,
          icon: 'question',
        }).then((res) => {
          if (res.isConfirmed) 
            {
            try {
              setLoading(true);
              setIsSubmit(true);
               DemandeQard.UtilDemande=user.coduti;
               DemandeQard.CodeUti=user.coduti;
              let data = Crypter.encrypt(JSON.stringify(DemandeQard));

              let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.DemandeQard,
                headers: {
                  Authorization: authHeader(),
                  'Content-Type': 'application/json',
                },
                data: data,
              };

              axios
                .request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                    if (res.StatutCode == 200) {
                      initialiazeButton();
                      form.resetFields();
                      // ✅ Vider le tableau après enregistrement réussi
                      setGarantiesTableau([]);
                      setImpActive(false);
                      SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                    } else {
                      SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error);
                  SweetAlert.fire({ title: error, icon: 'error' });
                });
            } catch (error) {
              SweetAlert.fire({
                title: 'Error ocured while getting warranties or avalistes',
                icon: 'error',
              });
            }
          }
        });
      }

      if (sbmit === 'update') {
        SweetAlert.fire({
          title: 'Voulez-vous modifier la demande de financement ' + values.NumeroDemande + ' ?',
          showCancelButton: true,
          color: 'green',
          confirmButtonText: 'Yes',
          confirmButtonColor: 'green',
          cancelButtonColor: 'darkred',
          cancelButtonText: 'No',
          showLoaderOnConfirm: true,
          icon: 'question',
        }).then((res) => {
          if (res.isConfirmed) {
            try {
              setLoading(true);
              setIsSubmit(true);
              DemandeQard.CodeUti=user.coduti;
              
              
              let data = Crypter.encrypt(JSON.stringify(DemandeQard));

              let config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.UpdateFindQard,
                headers: {
                  Authorization: authHeader(),
                  'Content-Type': 'application/json',
                },
                data: data,
              };

              axios
                .request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                    if (res.StatutCode == 200) {
                      initialiazeButton();
                      form.resetFields();
                      // ✅ Vider le tableau après enregistrement réussi
                      setGarantiesTableau([]);
                      setImpActive(false);
                      SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                    } else {
                      SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                    }
                  }
                  
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error);
                  SweetAlert.fire({ title: error, icon: 'error' });
                });
            } catch (error) {
              SweetAlert.fire({
                title: 'Error ocured while getting warranties or avalistes',
                icon: 'error',
              });
            }
          }
        });
      }
    // } else {
    //   SweetAlert.fire({
    //     title: "Vous devez d'abord sélectionner les garanties de financement avant d'enregistrer",
    //     icon: 'warning',
    //   });
    // }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + '');
    });
    SweetAlert.fire({
      title: 'Veuillez remplir tous les champs obligatoires',
      text: errors.toString().replaceAll(',', ' - '),
      icon: 'warning',
      confirmButtonText: 'OK',
    });
  };

  function consult() {
    let data = Crypter.encrypt(form.getFieldValue('NumeroDemande'));
    let numdemande = form.getFieldValue('NumeroDemande');
    let dataction = Crypter.encrypt('READ_DEMANDE');

    if (data.length != 0) {
      form.setFieldValue('garantie', '');
      form.setFieldValue('avaliste', '');
      initialiazeButton();
      setLoading(true);
      form.resetFields();
      form.setFieldValue('NumeroDemande', numdemande);

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFiancementQard,
        headers: {
          CypherNumeroDemandeQard: data,
          CypherAction: dataction,
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
      };

      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
       
              form.setFieldsValue(res.Result.Table1[0]);
              form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));

               form.setFieldValue('lib_NUMCLI',res.Result.Table1[0].NOMCLI);

              localStorage.clear();
              consultTypecard();
              // alert(JSON.stringify(res.Result.Table2));

              // ✅ FIX 6: Charger les garanties depuis l'API dans le state React de Tab2
              const garantiesRetournees: DataTypeTable[] = [];
              //res.Result.Table2 || [];
          if(res.Result.Table2)
          {
                // garantiesRetournees= res.Result.Table2.map((data:any,index:number)=>
                //   ({...data, valCouvert:data.montantcouvert}));
              res.Result.Table2.map((data:any,index:number)=>{garantiesRetournees.push({ ...data, valCouvert:data.MontantCouvert})})
            }
              setGarantiesTableau(garantiesRetournees);
              localStorage.setItem(Data.LocalVariable.garantie,JSON.stringify(garantiesRetournees));

              initialiazeButton();
              cunsultButton();
            } else {
              localStorage.removeItem(Data.LocalVariable.reset);
              SweetAlert.fire({ title: res.Message, icon: 'warning' });
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset);
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
        });
    }
  }

  function modif() {
    modifButton();
  }

  function consultTypecard() {
    if (form.getFieldValue('CodeQard') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Qard ', icon: 'warning' });
    } else {
      let data = form.getFieldValue('CodeQard');
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsQard,
          headers: {
            CypherCodeQard: Crypter.encrypt(data),
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };

        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                
              if (res.StatutCode == 200) {
                let paramsQardData: ParamsQard = res.Result.Table1[0];
             
                paramsQardData.Frais = res.Result.Table2.map((x: any) => x.CODOPE);

                setParamsQard(paramsQardData);
                form.setFieldValue('CodeFrais', paramsQardData.Frais);
  
              } else {
                SweetAlert.fire({ title:res.Message, text: res.Result, icon: 'warning' });
              }
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
          });
      }
    }
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle">
        <b>{window.location.pathname}</b>
      </Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          disabled={!ajoutActve}
          autoComplete="off"
          preserve
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend>
              <Typography color={'darkgreen'}>Actions</Typography>
            </legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={consulActive}
                  onClick={consult}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Consulter
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={ajoutActve}
                  onClick={SetStart}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Ajouter
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={modifActve}
                  onClick={modif}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Modifier
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={enregActve}
                  type="ghost"
                  htmlType="submit"
                  block
                >
                  Enregistrer
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  onClick={SetEndStart}
                  disabled={supActive}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Supprimer
                </Button>
                <Button
                  size="large"
                  onClick={handleApercu}
                  className="bt_add"
                  disabled={impActive}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Aperçu
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={actuActive}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Actualiser
                </Button>
                <Button
                  size="large"
                  disabled={annulActive}
                  onClick={handleAnulle}
                  className="bt_add"
                  type="ghost"
                  htmlType="reset"
                  block
                >
                  Annuler
                </Button>
              </Space>
            </Form.Item>
            <HelpInfos helpInfo={HelpData.Pret.DemandeDePret as Help} />
          </div>
          <div className="clientP">
            <div>
              <Tabs size="large" type="card" defaultActiveKey="1" items={items}  />
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default DemandeQard;